import PropTypes from 'prop-types';

export const ConnectionShape = PropTypes.shape({
  user: PropTypes.object,
  stream: PropTypes.object,
  ready: PropTypes.bool,
  video: PropTypes.any,
  id: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/redux/opentok/helpers/shapes.js